(ns rothko.form2.select.core
  (:require [clojure.string :as string]
            [rothko.dom.input :as dom-input]
            [rothko.form2.component :as form]))

(defn blur-handler
  [{:keys [::form/set-dirty!]} _event]
  (set-dirty!))

(defn- option-visible?
  [input {:keys [representation]}]
  (when representation
    (string/includes? (string/lower-case representation)
                      (string/lower-case input))))

(defn visible-options
  [input options]
  (let [option-visible? (partial option-visible? input)]
    (filter option-visible? options)))

(defn input-change-handler
  [!state _field-props input-value]
  (swap! !state
         (fn input-on-change
           [{:keys [options]
             :as   state}]
           (let [visible-options (->> options
                                      (visible-options input-value)
                                      vec)]
             (cond-> state
               :always (assoc :input input-value
                              :visible-options visible-options)))))
  input-value)

(defn input-on-focus-handler
  [!state {:keys [::form/set-clean!]
           :as   _field-props} event]
  (set-clean!)
  (dom-input/select event)
  (swap! !state assoc :show-options? true))

(defn close-options-handler
  [!state _]
  (swap! !state assoc :show-options? false))
